<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <h1 class="title is-5">{{ $t('routes.createExternalOrganizations') }}</h1>
      <div class="form-container">
        <ExternalOrganizationForm @save="save"></ExternalOrganizationForm>
      </div>
    </div>
  </DashboardLayout>
</template>

<script>
  import DashboardLayout from '@/components/DashboardLayout'
  import ExternalOrganizationForm from "@/components/ExternalOrganizationForm"

  export default {
    components: {
      ExternalOrganizationForm,
      DashboardLayout,
    },
    methods: {
      save(payload) {
        this.$store.dispatch('Moderator/create', {actionType: 'external_organizations', payload}).then(() =>
          this.$router.push({ name: 'externalOrganizations'}))
      }
    },
    mounted() {
      this.$store.dispatch('Moderator/getRelations', {actionType: 'external_organizations'})
    },
    computed: {
      breadcrumbs() {
        return [
          {name: 'externalOrganizations', path: 'externalOrganizations'},
          {name: 'createExternalOrganizations'}
        ]
      }
    }
  }
</script>